import React, { useEffect, useState } from 'react';
import './FeaturedShop.scss';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import { BREAKPOINTS } from '../../constants/breakpoints';

const DESKTOP_WIDTH = BREAKPOINTS.large;

const FeaturedShop = ({
  heading,
  description,
  cta,
  background_img_desktop,
  background_img_mobile,
  lightText = false,
}) => {
  const [isDesktop, setIsDesktop] = useState(null);

  useEffect(() => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > DESKTOP_WIDTH);
  };

  return (
    <div
      className="c-featured-shop"
      style={{
        backgroundImage: `url(${isDesktop ? background_img_desktop : background_img_mobile})`,
      }}
    >
      <div className="c-featured-shop__content">
        <h4
          className={`c-featured-shop__heading h4-right-grotesk color-${
            lightText ? 'white' : 'black'
          }`}
        >
          {heading}
        </h4>
        <p className={`c-featured-shop__description body-1 color-${lightText ? 'white' : 'black'}`}>
          {description}
        </p>
        <CTAButton link={cta.link} text={cta.label} type="primary" additionalClasses="cta" />
      </div>
    </div>
  );
};

export default FeaturedShop;
